import {TextArea} from '@/components/commons/textarea/TextArea'
import {PatientNotesFormValidationSchema} from '@/features/patients/types'
import {useController, useFormContext} from 'react-hook-form'

export const PatientNotesField = () => {
    const form = useFormContext<PatientNotesFormValidationSchema>()
    const {field} = useController({
        control: form.control,
        name: 'notes'
    })

    return <TextArea value={field.value ?? ''} onChange={field.onChange} />
}
